// Extract UTM/referrer attribution from the current URL and persist them
// per-session so they survive intra-app navigation until the user registers.

const KEY = "vd_utm";

export function captureUtmFromLocation() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v.trim().toLowerCase();
    });
    if (Object.keys(utm).length > 0) {
      utm.referrer = document.referrer || null;
      sessionStorage.setItem(KEY, JSON.stringify(utm));
    }
  } catch { /* ignore */ }
}

export function getUtmForRegistration() {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* ignore */ }
  // Fallback to current URL (page-first-load registrations)
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v.trim().toLowerCase();
    });
    if (Object.keys(utm).length > 0) {
      utm.referrer = document.referrer || null;
      return utm;
    }
  } catch { /* ignore */ }
  return {};
}
